/**
 * IP18 Banner — product bar pins to the viewport.
 * When the site header is sticky/fixed, pin under it; otherwise pin at top: 0.
 */
(function () {
  'use strict';

  function headerSection() {
    var nav = document.querySelector('header-navigation');
    if (!nav) return null;
    return nav.closest('[id^="shopify-section-"]') || nav;
  }

  function resolveTarget(href) {
    if (!href) return null;
    if (href.charAt(0) === '#') {
      var id = href.slice(1);
      if (!id) return null;
      return document.getElementById(id);
    }
    try {
      var url = new URL(href, window.location.href);
      if (url.pathname === window.location.pathname && url.hash) {
        return document.getElementById(url.hash.slice(1));
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  class Ip18Banner extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._slot = this.querySelector('[data-ip18-banner-slot]');
      this._bar = this.querySelector('[data-ip18-banner-bar]');
      this._links = Array.prototype.slice.call(this.querySelectorAll('[data-ip18-banner-nav]'));
      this._header = headerSection();
      this._onScroll = this._onScroll.bind(this);
      this._onNavClick = this._onNavClick.bind(this);
      this._syncPin = this._syncPin.bind(this);

      this._links.forEach(function (link) {
        link.addEventListener('click', this._onNavClick);
      }, this);

      this._ro = new ResizeObserver(this._syncPin);
      if (this._header) this._ro.observe(this._header);
      if (this._bar) this._ro.observe(this._bar);

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._syncPin, { passive: true });
      this._syncPin();
      this._onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._syncPin);
      if (this._ro) this._ro.disconnect();
      this._links.forEach(function (link) {
        link.removeEventListener('click', this._onNavClick);
      }, this);
    }

    _headerH() {
      if (!this._header) return 0;
      var pos = window.getComputedStyle(this._header).position;
      if (pos !== 'sticky' && pos !== 'fixed') return 0;
      return this._header.getBoundingClientRect().height;
    }

    _syncPin() {
      var h = this._headerH();
      this.style.setProperty('--ip18-banner-sticky-top', h + 'px');
      if (!this._slot || !this._bar) return;

      var slotTop = this._slot.getBoundingClientRect().top;
      if (slotTop <= h) {
        this._slot.style.height = this._bar.offsetHeight + 'px';
        this._bar.classList.add('is-fixed');
      } else {
        this._bar.classList.remove('is-fixed');
        this._slot.style.height = '';
      }
    }

    _offset() {
      return this._headerH() + (this._bar ? this._bar.offsetHeight : 0);
    }

    _onNavClick(e) {
      var href = e.currentTarget.getAttribute('href');
      var target = resolveTarget(href);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - this._offset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    }

    _onScroll() {
      this._syncPin();
      var offset = this._offset() + 8;
      var active = null;
      this._links.forEach(function (link) {
        var el = resolveTarget(link.getAttribute('href'));
        if (!el) return;
        if (el.getBoundingClientRect().top <= offset) active = link;
      });
      if (!active && this._links.length) active = this._links[0];
      this._links.forEach(function (link) {
        link.classList.toggle('is-active', link === active);
      });
    }
  }

  if (!customElements.get('ip18-banner')) {
    customElements.define('ip18-banner', Ip18Banner);
  }
})();
